module.exports = __webpack_public_path__ + "static/media/programming-code-svgrepo-com.f12e1fb7.svg";